<!--
  Enhanced template: shown when EITHER feature flag is on.
  4 logical branches via conditional bindings:
    Branch 1: Both flags OFF           → #oldTemplate (below)
    Branch 2: Datatable ON only        → ARIA on icons/toggle/ng-select host, no combobox/announcements
    Branch 3: Form dropdown ON only    → combobox/announcements/inputAttrs, no icon/toggle ARIA
    Branch 4: Both flags ON            → all features active
-->
<ng-container *ngIf="showEnhancedTemplate$ | async; else oldTemplate">
<div
  *ngIf="form"
  [formGroup]="form"
  class="form-group select2-form-group"
  style="margin-bottom: 43px"
>
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
      <i class="icon-info"
        [attr.role]="enableDataTableAccessibilityValue ? 'img' : null"
        [attr.aria-label]="enableDataTableAccessibilityValue ? infoText : null"
        [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info"
        [attr.role]="enableDataTableAccessibilityValue ? 'img' : null"
        [attr.aria-label]="enableDataTableAccessibilityValue ? infoText : null"
        [title]="infoText"></i>
    </span>
    <div *ngIf="(label)">
      <label *ngIf="!IsFormFieldNameHidden" [attr.for]="selectId" [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</label>
      <span *ngIf="
            ((required) || getErrorMessage() === error || control.hasValidator(validator)) && !(disabled || control.disabled || isHeader) &&
            !isConditionComponent
            " class="text-danger">
        *
      </span>
      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'"
          class="toggle-icon"
          [attr.tabindex]="enableDataTableAccessibilityValue ? '0' : null"
          [attr.role]="enableDataTableAccessibilityValue ? 'button' : null"
          [attr.aria-label]="enableDataTableAccessibilityValue ? (isTextVisible ? 'Hide information' : 'Show information') : null"
          [attr.aria-expanded]="enableDataTableAccessibilityValue ? isTextVisible : null"
          title="Toggle Text"
          *ngIf="AllowMinimize"
          (click)="toggleText()"
          (keydown)="handleToggleKeydown($event)"></i>
        <span [class.hidden-text]="!isTextVisible" class="info-text">
          {{ infoText }}
        </span>
      </span>
    </div>
  </div>

  <span *ngIf="enableFormDropdownNgSelectValue" [attr.id]="comboHintId" class="sr-only">{{ comboHintText }}</span>

  <ng-select
    *ngIf="isHeader"
    bindLabel="label"
    bindValue="value"
    class="ng-select-disabled"
    [multiple]="multiple"
    [items]="options"
    style="pointer-events: none;"
    [formControlName]="controlName"
    [virtualScroll]="isVirtualScroll()"
    appendTo="body"
    [placeholder]="getPlaceholder()"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark
    }"
    [labelForId]="enableFormDropdownNgSelectValue ? selectId : null"
    [attr.id]="!enableFormDropdownNgSelectValue ? selectId : null"
    [inputAttrs]="enableFormDropdownNgSelectValue ? ngSelectInputAttrs : {}"
    [attr.aria-label]="label || accessibleLabel"
    [attr.aria-disabled]="true"
    [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
    [attr.aria-invalid]="control.dirty && control.errors ? true : null"
    >
    <ng-template ng-label-tmp let-item="item">
      {{ item.label ? getFormattedLabel(item.label) : '-' }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.label ? getFormattedLabel(item.label) : '-' }}
    </ng-template>
  </ng-select>
  <ng-select
    *ngIf="!isHeader && !isCustomDropdown"
    [labelForId]="enableFormDropdownNgSelectValue ? selectId : null"
    [attr.id]="!enableFormDropdownNgSelectValue ? selectId : null"
    [inputAttrs]="enableFormDropdownNgSelectValue ? ngSelectInputAttrs : {}"
    bindLabel="label"
    bindValue="value"
    [formControlName]="controlName"
    [multiple]="multiple"
    [items]="options"
    [virtualScroll]="isVirtualScroll()"
    [closeOnSelect]="closeOnSelect"
    appendTo="body"
    [placeholder]="getPlaceholder()"
    [searchable]="isSearchable()"
    [minTermLength]="minSearchLength"
    (search)="onSearch($event)"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (clear)="onClear()"
    (close)="onDropdownClose()"
    (change)="change($event)"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark,
      input: disabled === true,
      'labelHidden': IsFormFieldNameHidden && !IsInfoVisible
    }"
    [attr.aria-label]="label || accessibleLabel"
    [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
    [attr.aria-invalid]="control.dirty && control.errors ? true : null"
    [attr.aria-required]="required"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div class="d-flex align-items-center">
        {{ item.label ? getFormattedLabel(item.label) : '-' }}
        <button *ngIf="showItemRemove && multiple" type="button" class="ng-value-remove-btn"
          (mousedown)="$event.stopPropagation()"
          (click)="clear(item); $event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          [attr.aria-label]="'Remove ' + (item.label ? getFormattedLabel(item.label) : 'item') + ' from ' + (label || accessibleLabel) + ' dropdown'">&times;</button>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div>
        {{ item.label ? getFormattedLabel(item.label) : '-' }}
        <span class="sr-only" *ngIf="enableFormDropdownNgSelectValue && isOptionSelected(item)">, selected</span>
      </div>
    </ng-template>
  </ng-select>
  <ng-select
    *ngIf="!isHeader && isCustomDropdown"
    [labelForId]="enableFormDropdownNgSelectValue ? selectId : null"
    [attr.id]="!enableFormDropdownNgSelectValue ? selectId : null"
    [inputAttrs]="enableFormDropdownNgSelectValue ? ngSelectInputAttrs : {}"
    bindLabel="label"
    bindValue="value"
    [formControlName]="controlName"
    [multiple]="multiple"
    [items]="options"
    [clearable]="false"
    [virtualScroll]="isVirtualScroll()"
    [closeOnSelect]="closeOnSelect"
    appendTo="body"
    [searchable]="isSearchable()"
    [placeholder]="getPlaceholder()"
    (close)="onDropdownClose()"
    (change)="change($event)"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark,
      input: disabled === true,
      'labelHidden': IsFormFieldNameHidden && !IsInfoVisible
    }"
    [attr.title]="selectedLabel"
    [attr.aria-label]="label || accessibleLabel"
    [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
    [attr.aria-invalid]="control.dirty && control.errors ? true : null"
    [attr.aria-required]="required"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div *ngIf="!item.value">{{ item.label ? item.label : '-' }}</div>
      <span class="d-flex align-items-center" *ngIf="item.value" [title]="item.label"><img height="25px" width="30px" class="mx-2" [src]='item.data' [alt]="item.label || 'Option'"> {{ item.label }}
        <button *ngIf="showItemRemove && multiple" type="button" class="ng-value-remove-btn"
          (mousedown)="$event.stopPropagation()"
          (click)="clear(item); $event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          [attr.aria-label]="'Remove ' + (item.label || 'item') + ' from ' + (label || accessibleLabel) + ' dropdown'">&times;</button>
      </span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div>
        <ng-container *ngIf="!item.value">{{ item.label ? item.label : '-' }}</ng-container>
        <span class="d-flex align-items-center" *ngIf="item.value" [title]="item.label"><img height="25px" width="30px" class="mx-2" [src]='item.data' [alt]="item.label || 'Option'"> {{ item.label }}</span>
        <span class="sr-only" *ngIf="enableFormDropdownNgSelectValue && isOptionSelected(item)">, selected</span>
      </div>
    </ng-template>
  </ng-select>
  <app-sr-only *ngIf="enableFormDropdownNgSelectValue">
    <div aria-live="polite" aria-atomic="true">
      {{ selectionAnnouncement }}
    </div>
  </app-sr-only>
  <div *ngIf="control.dirty && control.errors && control.touched" class="info-box error-box" style="margin-top: 8px" [attr.id]="errorId" role="alert" aria-live="polite">
    <span class="text-danger">{{ errorMessagePrefix + error }}</span>
  </div>
</div>
<div
  *ngIf="!form"
  class="form-group select2-form-group"
  style="margin-bottom: 43px"
>
  <span *ngIf="enableFormDropdownNgSelectValue" [attr.id]="comboHintId" class="sr-only">{{ comboHintText }}</span>
    <ng-select
    bindLabel="label"
    bindValue="value"
    [multiple]="multiple"
    [items]="options"
    [virtualScroll]="isVirtualScroll()"
    [closeOnSelect]="closeOnSelect"
    appendTo="body"
    [(ngModel)]="selectedValue"
    [placeholder]="getPlaceholder()"
    [searchable]="isSearchable()"
    [minTermLength]="minSearchLength"
    (search)="onSearch($event)"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (clear)="onClear(true)"
    (change)="change($event)"
    [labelForId]="enableFormDropdownNgSelectValue ? selectId : null"
    [attr.id]="!enableFormDropdownNgSelectValue ? selectId : null"
    [inputAttrs]="enableFormDropdownNgSelectValue ? ngSelectInputAttrs : {}"
    [attr.aria-label]="label || accessibleLabel"
    >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div class="d-flex align-items-center">
        {{ item.label ? getFormattedLabel(item.label) : '-' }}
        <button *ngIf="showItemRemove && multiple" type="button" class="ng-value-remove-btn"
          (mousedown)="$event.stopPropagation()"
          (click)="clear(item); $event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation(); clear(item)"
          [attr.aria-label]="'Remove ' + (item.label ? getFormattedLabel(item.label) : 'item') + ' from ' + (label || accessibleLabel) + ' dropdown'">&times;</button>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div>
        {{ item.label ? getFormattedLabel(item.label) : '-' }}
        <span class="sr-only" *ngIf="enableFormDropdownNgSelectValue && isOptionSelected(item)">, selected</span>
      </div>
    </ng-template>
  </ng-select>
</div>
</ng-container>

<!-- Branch 1: Original template (both flags OFF) -->
<ng-template #oldTemplate>
<div
  *ngIf="form"
  [formGroup]="form"
  class="form-group select2-form-group"
  style="margin-bottom: 43px"
>
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <div *ngIf="(label)">
      <label *ngIf="!IsFormFieldNameHidden" for="selectSearchScroll" [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</label>
      <span *ngIf="
            ((required) || getErrorMessage() === error || control.hasValidator(validator)) && !(disabled || control.disabled || isHeader) &&
            !isConditionComponent
            " class="text-danger">
        *
      </span>
      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'"
          class="toggle-icon"
          tabindex="0"
          role="button"
          [attr.aria-label]="isTextVisible ? 'Hide information' : 'Show information'"
          [attr.aria-expanded]="isTextVisible"
          title="Toggle Text"
          *ngIf="AllowMinimize"
          (click)="toggleText()"
          (keydown)="handleToggleKeydown($event)"></i>
        <span [class.hidden-text]="!isTextVisible" class="info-text">
          {{ infoText }}
        </span>
      </span>
    </div>
  </div>

  <ng-select
    *ngIf="isHeader"
    bindLabel="label"
    bindValue="value"
    class="ng-select-disabled"
    [multiple]="multiple"
    [items]="options"
    style="pointer-events: none;"
    [formControlName]="controlName"
    [virtualScroll]="isVirtualScroll()"
    appendTo="body"
    [placeholder]="getPlaceholder()"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark
    }"
    >
    <ng-template ng-label-tmp let-item="item">
      {{ item.label ? getFormattedLabel(item.label) : '-' }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.label ? getFormattedLabel(item.label) : '-' }}
    </ng-template>
  </ng-select>
  <ng-select
    *ngIf="!isHeader && !isCustomDropdown"
    [attr.id]="selectId"
    bindLabel="label"
    bindValue="value"
    [formControlName]="controlName"
    [multiple]="multiple"
    [items]="options"
    [virtualScroll]="isVirtualScroll()"
    appendTo="body"
    [placeholder]="getPlaceholder()"
    [searchable]="isSearchable()"
    [minTermLength]="minSearchLength"
    (search)="onSearch($event)"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (clear)="onClear()"
    (close)="onDropdownClose()"
    (change)="change($event)"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark,
      input: disabled === true,
      'labelHidden': IsFormFieldNameHidden && !IsInfoVisible
    }"
  >
    <ng-template ng-label-tmp let-item="item">
      <div>{{ item.label ? getFormattedLabel(item.label) : '-' }}</div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div>{{ item.label ? getFormattedLabel(item.label) : '-' }}</div>
    </ng-template>
  </ng-select>
  <ng-select
    *ngIf="!isHeader && isCustomDropdown"
    [attr.id]="selectId"
    bindLabel="label"
    bindValue="value"
    [formControlName]="controlName"
    [multiple]="multiple"
    [items]="options"
    [clearable]="false"
    [virtualScroll]="isVirtualScroll()"
    appendTo="body"
    [searchable]="isSearchable()"
    [placeholder]="getPlaceholder()"
    (close)="onDropdownClose()"
    (change)="change($event)"
    [ngClass]="{
      'is-invalid': control.dirty && control.errors,
      'required-mark': requiredMark,
      input: disabled === true,
      'labelHidden': IsFormFieldNameHidden && !IsInfoVisible
    }"
    [attr.title]="selectedLabel"
  >
    <ng-template ng-label-tmp let-item="item">
      <div *ngIf="!item.value">{{ item.label ? item.label : '-' }}</div>
       <span class="d-flex align-items-center " *ngIf="item.value" [title]="item.label"><img height="25px" width="30px"  class="mx-2" [src]='item.data' [alt]="item.label || 'Option'" > {{ item.label }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div *ngIf="!item.value">{{ item.label ? item.label : '-' }}</div>
       <span class="d-flex align-items-center " *ngIf="item.value" [title]="item.label"><img height="25px" width="30px"  class="mx-2" [src]='item.data' [alt]="item.label || 'Option'" > {{ item.label }}</span>
    </ng-template>
  </ng-select>
  <div *ngIf="control.dirty && control.errors && control.touched">
    <span class="text-danger">{{ errorMessagePrefix + error }}</span>
  </div>
</div>
<div
  *ngIf="!form"
  class="form-group select2-form-group"
  style="margin-bottom: 43px"
>
    <ng-select
    bindLabel="label"
    bindValue="value"
    [multiple]="multiple"
    [items]="options"
    [virtualScroll]="isVirtualScroll()"
    appendTo="body"
    [(ngModel)]="selectedValue"
    [placeholder]="getPlaceholder()"
    [searchable]="isSearchable()"
    [minTermLength]="minSearchLength"
    (search)="onSearch($event)"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (clear)="onClear(true)"
    (change)="change($event)"
    [closeOnSelect]="closeOnSelect"
    >
    <ng-template ng-label-tmp let-item="item">
      <div>{{ item.label ? getFormattedLabel(item.label) : '-' }}</div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div>{{ item.label ? getFormattedLabel(item.label) : '-' }}</div>
    </ng-template>
  </ng-select>
</div>
</ng-template>
